import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { AnyIfEmpty } from 'react-redux';
import { INVITE_STAFF_FAILURE, INVITE_STAFF_REQUEST, INVITE_STAFF_SUCCESS, STAFF_LIST_FAILURE, STAFF_LIST_REQUEST, STAFF_LIST_SUCCESS, VERIFY_STAFF_INVITATION_FAILURE, VERIFY_STAFF_INVITATION_REQUEST, VERIFY_STAFF_INVITATION_SUCCESS } from "../constants/invitedStaff.constants";

const inviteStaffRequest = () => {
    return {
        type: INVITE_STAFF_REQUEST,
    };
};

const inviteStaffSuccess = (data: AnyIfEmpty<object>) => {
    return {
        type: INVITE_STAFF_SUCCESS,
        payload: data,
    };
};

const inviteStaffFailure = (errorMsg: string) => {
    return {
        type: INVITE_STAFF_FAILURE,
        payload: errorMsg,
    };
};

const invitedStaffListRequest = () => {
    return {
        type: STAFF_LIST_REQUEST
    };
};

const invitedStaffListSuccess = (data: AnyIfEmpty<object>) => {
    return {
        type: STAFF_LIST_SUCCESS,
        payload: data,
    };
};

const invitedStaffListFailure = (errorMsg: string) => {
    return {
        type: STAFF_LIST_FAILURE,
        payload: errorMsg,
    };
};

const staffInvitationVerificationRequest = () => {
    return { type: VERIFY_STAFF_INVITATION_REQUEST }
}

const staffInvitationVerificationSuccess = (data: AnyIfEmpty<object>) => {
    return {
        type: VERIFY_STAFF_INVITATION_SUCCESS,
        payload: data
    }
}

const staffInvitationVerificationError = (errorMsg: string) => {
    return {
        type: VERIFY_STAFF_INVITATION_FAILURE,
        payload: errorMsg
    }
}

export const inviteStaff = (inviteStaffObj: AnyIfEmpty<object>, onSuccess?: (message: string) => void, onFailure?: (message: string) => void, setIsLoading?: Dispatch<SetStateAction<boolean>>) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(inviteStaffRequest());
        await axios
            .post('/admin/staff/invite', inviteStaffObj)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    dispatch(inviteStaffSuccess(response.data));
                    dispatch(invitedStaffList(inviteStaffObj?.locationId));
                    onSuccess && onSuccess(response?.data?.message)
                    setIsLoading && setIsLoading(false)
                } else {
                    dispatch(inviteStaffFailure(response?.data?.message));
                    onFailure && onFailure(response?.data?.message);
                    setIsLoading && setIsLoading(false);
                }
            })
            .catch((err) => {
                dispatch(inviteStaffFailure(err.message))
                onFailure && onFailure(err.message);
                setIsLoading && setIsLoading(false);
            });
    };
};

export const invitedStaffList = (propertyId: string) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(invitedStaffListRequest());
        await axios
            .get(`/admin/staff/list/${propertyId}`)
            .then((response) => {
                dispatch(invitedStaffListSuccess(response.data.data));
            })
            .catch((err) => dispatch(invitedStaffListFailure(err.message)));
    };
};

export const verifyInvitation = (propertyObj: AnyIfEmpty<object>, onSuccess?: (message: string, statusCode: number) => void, onFailure?: (message: string, statusCode: number) => void) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(staffInvitationVerificationRequest())
        await axios
            .post('/admin/staff/verified', propertyObj)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    dispatch(staffInvitationVerificationSuccess(response?.data?.data))
                    onSuccess && onSuccess(response?.data?.message, response?.data?.statusCode);
                } else if (response?.data?.statusCode === 404) {
                    onFailure && onFailure(response?.data?.message, response?.data?.statusCode);
                } else {
                    dispatch(staffInvitationVerificationError(response?.data?.message))
                    onFailure && onFailure(response?.data?.message, response?.data?.statusCode);
                }
            })
            .catch((err) => {
                dispatch(staffInvitationVerificationError(err.message))
                onFailure && onFailure(err.message, err.statusCode);
            });
    };
}

export const removeStaff = (removeStaffObj: AnyIfEmpty<object>, onSuccess?: (message: string) => void, onFailure?: (message: string) => void) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        await axios
            .delete('/admin/staff/remove', { data: removeStaffObj })
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    dispatch(invitedStaffList(removeStaffObj?.locationId));
                    onSuccess && onSuccess(response?.data?.message);
                } else {
                    onFailure && onFailure(response?.data?.message);
                }
            })
            .catch((err) => {
                onFailure && onFailure(err.message);
            });
    };
};

export const reInviteStaff = (inviteStaffObj: AnyIfEmpty<object>, onSuccess?: (message: string) => void, onFailure?: (message: string) => void) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(inviteStaffRequest());
        await axios
            .post('/admin/staff/re-invite', inviteStaffObj)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    dispatch(inviteStaffSuccess(response.data));
                    dispatch(invitedStaffList(inviteStaffObj?.locationId));
                    onSuccess && onSuccess(response?.data?.message)
                } else {
                    dispatch(inviteStaffFailure(response?.data?.message));
                    onFailure && onFailure(response?.data?.message);
                }
            })
            .catch((err) => {
                dispatch(inviteStaffFailure(err.message))
                onFailure && onFailure(err.message);
            });
    };
};